import React, { FC, useEffect, useState } from 'react';
import './TeamIcon.scss';
import { ReactComponent as PartyHat } from '../../../assets/party-hat.svg';

type Shape = "Circle" | "Small Circle" | "Rank Logo"

interface props {
    emoji: string,
    color: string,
    shape: Shape,
    rank?: number,
    partyTime?: boolean,
    hatColor?: string,
}

const emojiMap: Record<string, string> = {
    "0x1f36c": "https://www.blaseball.com/static/media/1f36c.51417d2d8b79f962ee5e.svg",
    "0x1f48b": "https://www.blaseball.com/static/media/1f48b.9dbd4487e1530f5e89b3.svg",
    "0x1f339": "https://www.blaseball.com/static/media/1f339.de10b57343388128e373.svg",
    "0x1f5e3": "https://www.blaseball.com/static/media/1f5e3.da99ffe6dacb0fcd5802.svg",
    "0x1f32e": "https://www.blaseball.com/static/media/1f32e.039169b0d9065a17ef09.svg",
    "0x1f4f1": "https://www.blaseball.com/static/media/1f4f1.81cbcbdf83a210eac619.svg",
    "0x1f31e": "https://www.blaseball.com/static/media/1f31e.1ad4f45caca017fd9a5d.svg",
    "0x1f45f": "https://www.blaseball.com/static/media/1f45f.85df0572d2a275bfa453.svg",
    "0x1f980": "https://www.blaseball.com/static/media/1f980.84707dca55b7ad461f17.svg",
    "0x1f405": "https://www.blaseball.com/static/media/1f405.a7b7b0b82b00cffd3db5.svg",
    "0x1f967": "https://www.blaseball.com/static/media/1f967.4b41762b68b035bc4268.svg",
    "0x1f6a4": "https://www.blaseball.com/static/media/1f6a4.77b85959044d03399d51.svg",
    "0x1f531": "https://www.blaseball.com/static/media/1f531.6c919e01632d0c6d0d77.svg",
    "0x1f6e0": "https://www.blaseball.com/static/media/1f6e0.18a6a1b2b9f68a15332f.svg",
    "0x1f575": "https://www.blaseball.com/static/media/1f575.f51f86d7fa8f75aedad9.svg",
    "0x1f450": "https://www.blaseball.com/static/media/1f450.9d2298e167cf4bfa214b.svg",
    "0x1f969": "https://www.blaseball.com/static/media/1f969.712e038d4ffa7be46f2a.svg",
    "0x1f525": "https://www.blaseball.com/static/media/1f525.45faba1660b5abaf0f4f.svg",
    "0x1f357": "https://www.blaseball.com/static/media/1f357.9303970901e78261de72.svg",
    "0x2728": "https://www.blaseball.com/static/media/2728.5df680186a4bdc43d2cc.svg",
    "0x1f3b8": "https://www.blaseball.com/static/media/1f3b8.fb578639ce6c3132c4bf.svg",
    "0x1f40c": "https://www.blaseball.com/static/media/1f40c.b7960ce48426447fe5d1.svg",
    "0x1f3dd": "https://www.blaseball.com/static/media/1f3dd.2bbd0e570e55222e24cf.svg",
    "0x1f3cb": "https://www.blaseball.com/static/media/1f3cb.d137320aa2d34b0516b5.svg",
}

const TeamIcon: FC<props> = (props) => {
    const { emoji, color, shape, rank } = props;
    const { partyTime = false, hatColor = "white" } = props;

    const src = emojiMap[emoji.toLowerCase()];

    const [rotate, setRotate] = useState<number>(-30);

    useEffect(() => {
        function newRotate() {
            const rotate = Math.round((Math.random() * 40) - 50);
            setRotate(rotate);
        }
        const handle = window.setInterval(newRotate, 2000);
        return () => { window.clearInterval(handle) }

    }, [])


    if (shape === "Circle" || shape === "Small Circle") {
        const size = (shape === "Circle") ? 36 : 30;
        const imageSize = (shape === "Circle") ? 16 : 14;
        const style: React.CSSProperties = { backgroundColor: color, width: size, height: size };
        style.opacity = (emoji) ? 1 : 0;
        style.transition = (emoji) ? "opacity 1s" : "opacity 0s";

        const imageStyle: React.CSSProperties = { width: imageSize, height: imageSize }


        return (
            //<div className={"TeamIcon font" + fontSize} style={style} dangerouslySetInnerHTML={{ __html: actualEmoji }} />
            <div className='TeamIcon-Circle' style={style}>
                <img src={src} style={imageStyle} alt={String.fromCodePoint(parseInt(emoji, 16))} />
            </div>
        );
    }
    if (shape === "Rank Logo") {
        const style: React.CSSProperties = { backgroundColor: color };

        const imageStyle: React.CSSProperties = { width: 14, height: 14 }


        return <div className='TeamIcon-RankLogo' >
            <div className='rank'>{rank}</div>
            <div className='logo' style={style}>
                {
                    partyTime && <PartyHat className='partyHat' style={{ color: hatColor, transform: `rotate(${rotate}deg)` }} title="Party Time" />
                }
                <img src={src} style={imageStyle} alt={String.fromCodePoint(parseInt(emoji, 16))} />
            </div>
        </div>
    }


    return <>
    </>
};


export default TeamIcon;
